import { COINS_DISABLED } from '../config/coinsFlag';
import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import './CoinsPopup.css';

function CoinsPopup() {
  const { showCoinsPopup, setShowCoinsPopup, user } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (showCoinsPopup) {
      const timer = setTimeout(() => {
        setShowCoinsPopup(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showCoinsPopup, setShowCoinsPopup]);

  if (COINS_DISABLED) return null;
  if (!showCoinsPopup) return null;

  return (
    <div className="coins-popup-overlay" onClick={() => setShowCoinsPopup(false)}>
      <div className="coins-popup" onClick={(e) => e.stopPropagation()}>
        <div className="coins-popup-content">
          <div className="coins-popup-icon">🎉</div>
          <h3 className="coins-popup-title">{t('signupSuccessTitle')}</h3>
          <p className="coins-popup-message">
            {t('signupSuccessSubtitle').replace('{coins}', user?.coins || 5)}
          </p>
          <div className="coins-display">
            <span className="coins-badge">
              🪙 {user?.coins || 5} {t('walletCoinsLabel')}
            </span>
          </div>
          <button
            onClick={() => setShowCoinsPopup(false)}
            className="btn btn-primary"
            data-testid="close-popup"
          >
            {t('signupSuccessCta')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CoinsPopup;
